import { planTooltipLabels } from '@zorro/types';

import { PlanBadge } from '../PlanBadge';

type Props = {
  hsaEligible?: boolean | null;
};

export const HsaEligibleBadge = ({ hsaEligible }: Props) => {
  if (!hsaEligible) {
    return null;
  }

  return (
    <PlanBadge tooltipLabel={planTooltipLabels.hsa} label="HSA" size="sm" />
  );
};
